<div class="flex flex-col gap-0.5">
  <!-- Dirección con ícono de mapa -->
  <div class="flex items-center gap-1">
    <button
      mat-icon-button
      class="!h-6 !w-6"
      [disabled]="!hasGeolocation()"
      (click)="openMapModal()"
      [matTooltip]="
        hasGeolocation()
          ? ('routing.SUB_ROUTE_PARTNERS.CELLS.ADDRESS_MAP_TOOLTIP' | t)
          : ('routing.SUB_ROUTE_PARTNERS.CELLS.ADDRESS_NO_GEO_TOOLTIP' | t)
      "
    >
      <mat-icon
        class="!text-base"
        [class]="hasGeolocation() ? 'text-primary-500' : 'text-orange-500'"
        svgIcon="heroicons_solid:map-pin"
      ></mat-icon>
    </button>
    @if (address()) {
      <span class="max-w-[200px] truncate text-sm text-gray-700" [matTooltip]="address()!">
        {{ address() }}
      </span>
    } @else {
      <span class="text-sm text-gray-400">-</span>
    }
  </div>

  <!-- Ubicación (ciudad, municipio) -->
  @if (locationText()) {
    <span class="ml-7 max-w-[220px] truncate text-xs text-gray-500" [matTooltip]="locationText()!">
      {{ locationText() }}
    </span>
  }
</div>
